// TikTok Pixel helpers. The pixel ID is configured per campaign, so the base code is injected at
// runtime rather than hard-coded in index.html.

const PIXEL_ID_PATTERN = /^[A-Za-z0-9]{10,32}$/;

export const isValidTikTokPixelId = (pixelId) => PIXEL_ID_PATTERN.test(String(pixelId || '').trim());

// Standard TikTok Pixel base snippet, equivalent to the code TikTok provides (without the load/page calls).
const installBaseCode = () => {
  const w = window;
  const t = 'ttq';
  w.TiktokAnalyticsObject = t;
  const ttq = (w[t] = w[t] || []);
  if (ttq.load && ttq._i) return;

  ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
  ttq.setAndDefer = (target, method) => {
    target[method] = (...args) => {
      target.push([method].concat(args));
    };
  };
  ttq.methods.forEach((method) => ttq.setAndDefer(ttq, method));
  ttq.instance = (id) => {
    const instance = (ttq._i && ttq._i[id]) || [];
    ttq.methods.forEach((method) => ttq.setAndDefer(instance, method));
    return instance;
  };
  ttq.load = (id, options) => {
    const src = 'https://analytics.tiktok.com/i18n/pixel/events.js';
    ttq._i = ttq._i || {};
    ttq._i[id] = [];
    ttq._i[id]._u = src;
    ttq._t = ttq._t || {};
    ttq._t[id] = +new Date();
    ttq._o = ttq._o || {};
    ttq._o[id] = options || {};
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `${src}?sdkid=${id}&lib=${t}`;
    document.head.appendChild(script);
  };
};

const initialisedPixels = new Set();

// Safe to call repeatedly: each pixel ID is loaded (and its page view fired) once per page load.
export const initTikTokPixel = (pixelId) => {
  const id = String(pixelId || '').trim();
  if (!isValidTikTokPixelId(id) || initialisedPixels.has(id)) return false;
  installBaseCode();
  window.ttq.load(id);
  window.ttq.page();
  initialisedPixels.add(id);
  return true;
};

export const trackTikTokEvent = (eventName, pixelId) => {
  const id = String(pixelId || '').trim();
  if (!isValidTikTokPixelId(id) || !window.ttq || typeof window.ttq.track !== 'function') return;
  window.ttq.track(eventName);
};
